// extracted by mini-css-extract-plugin
export default {"wrapper":"ViewModeMenu_wrapper__qU46p"};